import { useState, useEffect } from 'react';
import { mutate } from 'swr';
import apiClient from '../../utils/axiosConfig';
import { useQuery } from '../../hook/useQuery';


export const useAdvertisements = () => {
    const [itemsPerPage, setPerPge] = useState(50)
    const [page, setPage] = useState(1);
    const [queryString, setQueryString] = useState(' ')
    const { filterUrl } = useQuery();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [advertisements, setAdvertisements] = useState([]);
    const [total, setTotal] = useState([]);
    const [lastPage, setLastPage] = useState([]);

    const fetchData = async () => {
        const queryString = filterUrl() || '';
        const url = `/advertisement?perPage=${itemsPerPage}&page=${page}&${queryString}`;
        try {
            const response = await apiClient.get(url);
            await mutate(`/advertisement?perPage=${itemsPerPage}&page=${page}&${queryString}`);
            setData(response?.data);
            setError(null);
        } catch (err) {
            setError(err.response?.data || 'An error occurred');
            setData(null);
        }
    };

    useEffect(() => {
        if (data?.data?.advertisements?.data) {
            setAdvertisements([...data?.data?.advertisements?.data]);
            setTotal(data?.data?.advertisements?.total);
            setLastPage(data?.data?.advertisements?.last_page);
        }
    }, [data]);

    const createAdvertisement = async (newData) => {
        try {
            const response = await apiClient.post('/advertisement', newData, false);
            mutate(`/advertisement?perPage=${itemsPerPage}&page=${page}`);
            return response.data;
        } catch (err) {
            return err.response.data;
        }
    };

    const updateAdvertisement = async (id, formData) => {
        try {
            const response = await apiClient.put(`/advertisement/${id}`, formData);
            mutate(`/advertisement?perPage=${itemsPerPage}&page=${page}`);
            mutate(`/advertisement/${id}`)
            return response.data;
        } catch (err) {
            return err.response.data;
        }
    };

    const deleteAdvertisement = async (id) => {
        try {
            const response = await apiClient.delete(`/advertisement/${id}`);
            mutate(`/advertisement?perPage=${itemsPerPage}&page=${page}`);
            return response.data;
        } catch (err) {
            return err.response.data;
        }
    };



    const getAdvertisementById = async (advertisementId) => {
        const response = await apiClient.get(`/advertisement/${advertisementId}`);
        return response.data;
    };

    const updateStatus = async (id) => {
        try {
            const response = await apiClient.put(`/advertisement/${id}/status`);
            mutate(`/advertisement?perPage=${itemsPerPage}&page=${page}`);
            return response.data;
        } catch (err) {
            return err.response.data;
        }
    };
    const getAll = async () => {
        try {
            const response = await apiClient.get(`/advertisement`);
            mutate(`/advertisement`);
            return Array.isArray(response?.data?.data?.advertisements) ? response?.data?.data?.advertisements : [];
        } catch (err) {
            return err.response.data;
        }
    }
    return {
        advertisements,
        fetchData,
        isLoading: !error && !data,
        isError: error,
        itemsPerPage,
        lastPage,
        currentPage: page,
        total,
        updateStatus,
        setPage,
        createAdvertisement,
        updateAdvertisement,
        deleteAdvertisement,
        getAdvertisementById,
        mutate,
        setPerPge,
        getAll,
        setQueryString,
        queryString
    };
};